import CancelIcon from "@mui/icons-material/Cancel";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PaidIcon from "@mui/icons-material/Paid";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { IComissionData } from "../../types/types";
import { checkByProfileGuard } from "../../../../shared/guards/ProfileGuard";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../../shared/enums/profiles";

export type ComissionMenuModalType = "details" | "cancel" | "resendEmail" | "manualPayment" | "pdf" | "export" | "launch";

interface ComissionMenuProps {
	anchorEl: null | HTMLElement;
	open: boolean;
	onClose: () => void;
	selectedRow: IComissionData | null;
	onOpenModal: (type: ComissionMenuModalType, row: IComissionData) => void;
}

export const ComissionMenu = ({ anchorEl, open, onClose, selectedRow, onOpenModal }: ComissionMenuProps) => {
	if (!selectedRow) return null;

	console.log("selectedRow", selectedRow);
console.log('25....',
	checkByProfileGuard(PermissionRolesEnum.ComissionOptions, PermissionActionsEnum.Update),
PermissionRolesEnum.ComissionOptions, 
PermissionActionsEnum.Update
)
	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("details", selectedRow);
				}}
			>
				<ListItemIcon>
					<VisibilityIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Visualizar detalhes" />
			</MenuItem>

			<Divider />

			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("pdf", selectedRow);
				}}
			>
				<ListItemIcon>
					<PictureAsPdfIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Baixar PDF" />
			</MenuItem>

			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("export", selectedRow);
				}}
			>
				<ListItemIcon>
					<FileDownloadIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Baixar CSV" />
			</MenuItem>

			<Divider />

			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("launch", selectedRow);
				}}
				disabled = {!checkByProfileGuard(PermissionRolesEnum.ComissionOptions, PermissionActionsEnum.Add)}
			>
				<ListItemIcon>
					<RocketLaunchIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Lançamento" />
			</MenuItem>

			<Divider />

			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("manualPayment", selectedRow);
				}}
				disabled = {!checkByProfileGuard(PermissionRolesEnum.ComissionOptions, PermissionActionsEnum.Update)}
			>
				<ListItemIcon>
					<PaidIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Pagamento manual" />
			</MenuItem>

			<Divider />

			<MenuItem
				onClick={() => {
					onClose();
					onOpenModal("cancel", selectedRow);
				}}
				disabled = {!checkByProfileGuard(PermissionRolesEnum.ComissionOptions, PermissionActionsEnum.Cancel)}
			>
				<ListItemIcon>
					<CancelIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Cancelar" />
			</MenuItem>
		</Menu>
	);
};
